export default "__VITE_ASSET__DNrUn10E__"